export default __webpack_public_path__ + "static/media/KF-sponsor-logo.7914fef1.png";